import {
    ADD_PERMISSION,
    ALL_PERMISSION,
    GET_PERMISSION,
    EDIT_PERMISSION
  } from "./actionTypes"
  
  export const addPermission = (permission,history) => {
    return {
      type: ADD_PERMISSION,
      payload: { permission,history},
    }
  }

  export const getPermission = (data) => {
    return {
      type: GET_PERMISSION,
      payload: { data },
    }
  }

  export const allPermissions = permissions => {
    return {
      type: ALL_PERMISSION,
      payload: permissions,
    }
  }

  export const editPermissions = (permission,history) => {
    return {
      type: EDIT_PERMISSION,
      payload:{permission,history},
    }
  }